<template>
  <a-config-provider>
    <template #renderEmpty>
      <div style="text-align: center">
        <a-icon :type="iconSelect" :spin="iconSelect === 'sync'" style="font-size: 20px"/>
        <p>{{message}}</p>
      </div>
    </template>
  <a-select v-model="iValue"
            allowClear
            show-search
            :loading="loading"
            :disabled="disabled"
            :placeholder="placeholder"
            :options="options"
            :filter-option="false"
            :default-active-first-option="false"
            @change="handleChange"
            @search="handleSearch"
            v-bind="slConfig">
    <template v-for="customSlot in customSlots" :slot="customSlot">
      <slot :name="customSlot"></slot>
    </template>
  </a-select>
  </a-config-provider>
</template>
<script>
  import JsUtils from '@/util/JsUtils'
  import JqHttpUtil from '@/util/JqHttpUtil'
  const INFO = {
    SEARCH: 0,
    NOTFOUND: 1,
    LOADING: 2
  }

  export default {
    props: ['value', 'selectedObj', 'placeholder', 'endpoint', 'selectConfig', 'cache', 'params', 'disabled', 'count', 'customSlots'],
    data () {
      return {
        iValue: undefined,
        options: [],
        loading: false,
        lastTimeout: null,
        slConfig: {},
        iconSelect: 'info-circle',
        message: 'Empiece a escribir para buscar...',
        info: INFO
      }
    },
    mounted () {
      this.slConfig = {...this.slConfig, ...this.selectConfig}
      this.httpClient = new JqHttpUtil(this.endpoint + '/lookup')
      this.iValue = this.value && this.value.toString()
      this.updateDescription()
    },
    methods: {
      resultsFound (value) {
        switch (value) {
          case this.info.SEARCH:
            this.iconSelect = 'info-circle'
            this.message = 'Empiece a escribir para buscar...'
            break
          case this.info.NOTFOUND:
            this.iconSelect = 'exclamation-circle'
            this.message = 'No se encontraron resultados...'
            break
          case this.info.LOADING:
            this.iconSelect = 'sync'
            this.message = 'Buscando...'
            break
        }
      },
      updateDescription () {
        if (JsUtils.isEmpty(this.iValue)) {
          return
        }
        this.loading = true
        this.httpClient.baseGet(this.endpoint + '/lookup_description', {
          ...this.params,
          ddvalue: this.iValue
        }, {
          cache: typeof this.cache === 'undefined' ? true : this.cache
        }, response => {
          this.clearOptions()
          if (JsUtils.isEmpty(response)) {
            this.options.push({
              value: '',
              key: 'na',
              label: 'No encontrado',
              disabled: true
            })
            this.clear()
          } else {
            this.addOptions(this.transformOptions([response]))
            this.updateSelectedObj(this.iValue)
          }
        }, error => {
          console.log(error)
          this.clearOptions()
          this.options.push({
            value: '',
            key: 'na',
            label: 'No encontrado',
            disabled: true
          })
          this.clear()
        }).always(() => {
          this.loading = false
        })
      },
      search (value) {
        if (this.lastRequest) {
          this.lastRequest.abort()
        }
        if (JsUtils.isEmpty(value)) {
          this.resultsFound(this.info.SEARCH)
          return
        }
        this.loading = true
        this.resultsFound(this.info.LOADING)
        this.lastRequest = this.httpClient.get({
          ...this.params,
          ddquery: value
        }, {
          cache: typeof this.cache === 'undefined' ? true : this.cache
        }, response => {
          this.clearOptions()
          if (response.data.length === 0) {
            this.resultsFound(this.info.NOTFOUND)
          } else {
            this.addOptions(this.transformOptions(response.data))
          }
        }, () => {
          this.clearOptions()
          this.resultsFound(this.info.LOADING)
          this.clear()
        }).always(() => {
          this.loading = false
        })
      },
      handleSearch (value) {
        clearTimeout(this.lastTimeout)
        this.lastTimeout = setTimeout(() => {
          this.search(value, false)
        }, 300)
      },
      transformOptions (response) {
        return response.map(option => {
          return {
            value: option.value.toString(),
            key: option.value.toString(),
            label: option.text,
            obj: option
          }
        })
      },
      handleChange (value) {
        this.$emit('input', value)
        this.$emit('change', value)
        this.updateSelectedObj(value)
      },
      updateSelectedObj (value) {
        for (let i = 0; i < this.options.length; i++) {
          const option = this.options[i]

          if (option.value === value) {
            this.$emit('update:selectedObj', option.obj)
            return
          }
        }
        this.$emit('update:selectedObj', undefined)
      },
      clear () {
        this.iValue = undefined
        this.handleChange(undefined)
      },
      clearOptions () {
        this.options.splice(0, this.options.length)
      },
      addOptions (options) {
        this.options.push(...options)
      }
    },
    watch: {
      value () {
        if (this.iValue !== this.value) {
          this.iValue = this.value
          this.updateDescription()
        }
      },
      params () {
        // this.updateDescription()
      }
    }
  }
</script>


// WEBPACK FOOTER //
// src/customization/GlobalBPOCore/components/ui/v2/lookup.vue